import { render, staticRenderFns } from "./PartCategoryDetail.vue?vue&type=template&id=349db5be"
import script from "./PartCategoryDetail.vue?vue&type=script&lang=ts"
export * from "./PartCategoryDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports